'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeRecipe = changeRecipe;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* REDUX MAINTAIN RECIPE PAGE */

var CHANGE_RECIPE = 'CHANGE_RECIPE';

var initialState = {
  recipe: 0
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_RECIPE:
      return (0, _extends3.default)({}, state, {
        recipe: action.recipeid
      });
    default:
      return state;
  }
}

function changeRecipe(recipeID) {
  return {
    type: CHANGE_RECIPE,
    recipeid: recipeID
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/recipes.js
// module id = 324
// module chunks = 0